import { useTranslation } from 'module/hooks/use-translation';
import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import { faPenNib } from '@fortawesome/pro-regular-svg-icons';
import { Button } from '@rocketlane/ui';
import { Textarea } from '@rocketlane/ui';
import { isEmpty } from 'lodash';
import { FC, useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const TitleIcon = styled(FontAwesomeIcon).attrs({
  size: 12,
})``;
const Header = styled.div`
  display: flex;
  align-items: center;
  color: var(--purple-70);
  height: var(--height-header);
  padding: var(--spacing-02) var(--spacing-03);
  gap: var(--spacing-02);
`;
const TextArea = styled(Textarea)`
  border-color: transparent !important;
  outline-color: transparent !important;
  background-color: transparent !important;
`;
const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;
const Wrapper = styled.div`
  padding: var(--spacing-03);
  width: 320px;
  background-color: var(--purple-10);
`;

interface EnhanceWithNotesInputProps {
  onSubmit: (notes: string) => void;
}

export const EnhanceWithNotesInput: FC<EnhanceWithNotesInputProps> = ({
  onSubmit,
}) => {
  const [notes, setNotes] = useState('');
  const actionDisabled = isEmpty(notes);
  const handleSubmit = useCallback(() => {
    onSubmit(notes);
  }, [notes, onSubmit]);

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
      if (e.key === 'Enter') {
        if (e.shiftKey) {
          return;
        } else {
          e.preventDefault();
          if (!actionDisabled) {
            handleSubmit();
          }
        }
      }
    },
    [actionDisabled, handleSubmit],
  );

  return (
    <Wrapper>
      <Header>
        <TitleIcon icon={faPenNib} />
        <FormattedMessage id="editor.commands.ask_ai.enhance_with_notes.input.title" />
      </Header>
      <TextArea
        value={notes}
        onChange={(e) => setNotes(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder={useTranslation(
          'editor.commands.ask_ai.enhance_with_notes.input.placeholder',
        )}
        rows={1}
        maxRows={5}
        autoFocus
      />
      {!actionDisabled && (
        <Actions>
          <Button
            variant="primary"
            size="small"
            disabled={actionDisabled}
            onClick={handleSubmit}
          >
            <FormattedMessage id="editor.commands.ask_ai.enhance_with_notes.input.action_label" />
          </Button>
        </Actions>
      )}
    </Wrapper>
  );
};
